(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["responsive-image-gallery"] && !Shopify.designMode) return;
  try {
    
(function() {
  var root = document.querySelector('.ig-{{ gid }}');
  if (!root) return;

  var isMobileSlider = root.classList.contains('is-mobile-slider');
  var isDesktopSlider = root.classList.contains('is-desktop-slider');

  if (!isMobileSlider && !isDesktopSlider) return;

  var grid = root.querySelector('[data-grid]');
  if (!grid) return;

  /* ===========================
     SHARED HELPERS
  =========================== */
  function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }
  function colsMobile() { return parseInt('{{ section.settings.columns_mobile }}', 10) || 2; }
  function colsDesktop() { return parseInt('{{ section.settings.columns_desktop }}', 10) || 3; }

  function perPage() {
    return isMobile() ? Math.max(1, colsMobile()) : Math.max(1, colsDesktop());
  }
  function pageCount() {
    return Math.max(1, Math.ceil(grid.children.length / perPage()));
  }
  function pageIndexFromScroll() {
    var per = perPage(), total = pageCount();
    var left = grid.scrollLeft, best = 0, bestDist = Infinity;
    for (var i = 0; i < total; i++) {
      var idx = Math.min(grid.children.length - 1, i * per);
      var l = grid.children[idx].offsetLeft;
      var d = Math.abs(left - l);
      if (d < bestDist) { bestDist = d; best = i; }
    }
    return best;
  }

  /* ===========================
     MOBILE SLIDER
  =========================== */
  var mobileAutoplay = root.dataset.autoplay === 'true';
  var mobileInterval = parseInt(root.dataset.interval || '3500', 10);
  var mobileShowDots = root.dataset.showDots === 'true';
  var mobileShowArrows = root.dataset.showArrows === 'true';

  var controls = root.querySelector('[data-controls]');
  var dotsWrap = root.querySelector('[data-dots]');
  var prevBtn = root.querySelector('[data-prev]');
  var nextBtn = root.querySelector('[data-next]');

  var mobileDots = [], mobileCurrentPage = 0, mobileTimer = null;

  function buildMobileDots() {
    if (!mobileShowDots || !dotsWrap) return;
    dotsWrap.innerHTML = ''; mobileDots = [];
    for (var i = 0; i < pageCount(); i++) {
      var dot = document.createElement('span');
      dot.className = 'ig-dot' + (i === 0 ? ' is-active' : '');
      dot.dataset.index = String(i);
      dotsWrap.appendChild(dot);
      mobileDots.push(dot);
    }
  }
  function activateMobileDot(p) {
    if (!mobileShowDots) return;
    mobileDots.forEach(function(d, i) {
      i === p ? d.classList.add('is-active') : d.classList.remove('is-active');
    });
  }
  function goToMobilePage(p) {
    var per = perPage();
    var idx = Math.min(grid.children.length - 1, p * per);
    var el = grid.children[idx]; if (!el) return;
    grid.scrollTo({ left: el.offsetLeft, behavior: 'smooth' });
    activateMobileDot(p); mobileCurrentPage = p;
  }
  function mobileNext() { goToMobilePage((mobileCurrentPage + 1) % pageCount()); }
  function mobilePrev() { var t = pageCount(); goToMobilePage((mobileCurrentPage - 1 + t) % t); }
  function startMobile() {
    stopMobile();
    if (!mobileAutoplay || !isMobile() || !isMobileSlider) return;
    if (pageCount() <= 1) return;
    mobileTimer = setInterval(mobileNext, mobileInterval);
  }
  function stopMobile() { if (mobileTimer) { clearInterval(mobileTimer); mobileTimer = null; } }

  if (isMobileSlider) {
    if (mobileShowArrows && prevBtn) prevBtn.addEventListener('click', function(e) { e.preventDefault(); mobilePrev(); });
    if (mobileShowArrows && nextBtn) nextBtn.addEventListener('click', function(e) { e.preventDefault(); mobileNext(); });
    if (mobileShowDots && dotsWrap) {
      dotsWrap.addEventListener('click', function(e) {
        var dot = e.target.closest('.ig-dot'); if (!dot) return;
        e.preventDefault();
        goToMobilePage(parseInt(dot.dataset.index || '0', 10));
      });
    }
    grid.addEventListener('mouseenter', stopMobile);
    grid.addEventListener('mouseleave', startMobile);
    grid.addEventListener('touchstart', stopMobile, { passive: true });
    grid.addEventListener('touchend', startMobile, { passive: true });
  }

  /* ===========================
     DESKTOP SLIDER
  =========================== */
  var desktopAutoplay = root.dataset.desktopAutoplay === 'true';
  var desktopInterval = parseInt(root.dataset.desktopInterval || '4000', 10);
  var desktopShowDots = root.dataset.desktopShowDots === 'true';
  var desktopShowArrows = root.dataset.desktopShowArrows === 'true';

  var desktopControlsEl = root.querySelector('[data-controls-desktop]');
  var desktopDotsWrap = root.querySelector('[data-dots-desktop]');
  var desktopPrevBtn = root.querySelector('[data-desktop-prev]');
  var desktopNextBtn = root.querySelector('[data-desktop-next]');

  var desktopDots = [], desktopCurrentPage = 0, desktopTimer = null;

  function buildDesktopDots() {
    if (!desktopShowDots || !desktopDotsWrap) return;
    desktopDotsWrap.innerHTML = ''; desktopDots = [];
    for (var i = 0; i < pageCount(); i++) {
      var dot = document.createElement('span');
      dot.className = 'ig-dot-desktop' + (i === 0 ? ' is-active' : '');
      dot.dataset.index = String(i);
      desktopDotsWrap.appendChild(dot);
      desktopDots.push(dot);
    }
  }
  function activateDesktopDot(p) {
    if (!desktopShowDots) return;
    desktopDots.forEach(function(d, i) {
      i === p ? d.classList.add('is-active') : d.classList.remove('is-active');
    });
  }
  function goToDesktopPage(p) {
    var per = perPage();
    var idx = Math.min(grid.children.length - 1, p * per);
    var el = grid.children[idx]; if (!el) return;
    grid.scrollTo({ left: el.offsetLeft, behavior: 'smooth' });
    activateDesktopDot(p); desktopCurrentPage = p;
  }
  function desktopNext() { goToDesktopPage((desktopCurrentPage + 1) % pageCount()); }
  function desktopPrev() { var t = pageCount(); goToDesktopPage((desktopCurrentPage - 1 + t) % t); }
  function startDesktop() {
    stopDesktop();
    if (!desktopAutoplay || isMobile() || !isDesktopSlider) return;
    if (pageCount() <= 1) return;
    desktopTimer = setInterval(desktopNext, desktopInterval);
  }
  function stopDesktop() { if (desktopTimer) { clearInterval(desktopTimer); desktopTimer = null; } }

  if (isDesktopSlider) {
    if (desktopShowArrows && desktopPrevBtn) desktopPrevBtn.addEventListener('click', function(e) { e.preventDefault(); desktopPrev(); });
    if (desktopShowArrows && desktopNextBtn) desktopNextBtn.addEventListener('click', function(e) { e.preventDefault(); desktopNext(); });
    if (desktopShowDots && desktopDotsWrap) {
      desktopDotsWrap.addEventListener('click', function(e) {
        var dot = e.target.closest('.ig-dot-desktop'); if (!dot) return;
        e.preventDefault();
        goToDesktopPage(parseInt(dot.dataset.index || '0', 10));
      });
    }
    grid.addEventListener('mouseenter', stopDesktop);
    grid.addEventListener('mouseleave', startDesktop);
  }

  /* ===========================
     SHARED SCROLL LISTENER
  =========================== */
  grid.addEventListener('scroll', function() {
    var p = pageIndexFromScroll();
    if (isMobile()) {
      if (p !== mobileCurrentPage) { mobileCurrentPage = p; activateMobileDot(p); }
    } else {
      if (p !== desktopCurrentPage) { desktopCurrentPage = p; activateDesktopDot(p); }
    }
  });

  document.addEventListener('visibilitychange', function() {
    if (document.hidden) { stopMobile(); stopDesktop(); }
    else { startMobile(); startDesktop(); }
  });

  /* ===========================
     UPDATE UI ON RESIZE
  =========================== */
  function updateUI() {
    /* Mobile controls visibility */
    if (controls) {
      controls.style.display = (isMobile() && isMobileSlider && (mobileShowDots || mobileShowArrows)) ? 'flex' : 'none';
    }
    /* Desktop controls visibility */
    if (desktopControlsEl) {
      desktopControlsEl.style.display = (!isMobile() && isDesktopSlider && (desktopShowDots || desktopShowArrows)) ? 'flex' : 'none';
    }
    buildMobileDots(); activateMobileDot(mobileCurrentPage);
    buildDesktopDots(); activateDesktopDot(desktopCurrentPage);
  }

  if ('ResizeObserver' in window) {
    new ResizeObserver(function() { updateUI(); startMobile(); startDesktop(); }).observe(grid);
  } else {
    window.addEventListener('resize', function() { updateUI(); startMobile(); startDesktop(); });
  }

  /* Init */
  updateUI();
  mobileCurrentPage = pageIndexFromScroll();
  desktopCurrentPage = pageIndexFromScroll();
  activateMobileDot(mobileCurrentPage);
  activateDesktopDot(desktopCurrentPage);
  startMobile();
  startDesktop();
})();

  } catch(e) { console.error(e); }
})();
})();
